import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from './data/auth.service';

@Injectable({ providedIn: 'root' })
export class SchoolGuard  {

    constructor(private authService: AuthService, private router: Router) { }

    //if user is employee (or CL Admin), allow to access school pages
    //else if student, redirect user to the student dashboard
    canActivate(): Promise<boolean> {
        return new Promise((resolve) => {
            this.authService.getAuthInfo().subscribe(
                auth => {
                    if (auth && auth.isAuthenticated) {
                        if (auth.securityType.toLowerCase() === 'campuslogic' ||
                            auth.securityType.toLowerCase() === 'employee' ||
                            auth.securityType.toLowerCase() === 'externalreviewer') {
                            resolve(true);
                        } else if (auth.securityType.toLowerCase() === 'donor') {
                            this.router.navigate(['/donor']);
                            resolve(false);
                        } else {
                            this.router.navigate(['/student']);
                            resolve(false);
                        }
                    } else {
                        this.router.navigate(['/student']);
                        resolve(false);
                    }
                });
        });
    }

    canActivateChild = () => this.canActivate();

}
